import React from "react";
import { useOperatorContext } from "@src/context/operatorContext";
import OnboardingContainer from "./OnboardingContainer";
import { Modal } from "@src/components/atoms";
import { SectionContainer } from "@src/pages/sharedSections";
import { trackActionActivity } from "@src/utils/userActivityTracker";

const OnboardingWrapper = () => {
  const { onboardingOpen, setOnboardingOpen } = useOperatorContext();

  React.useEffect(() => {
    if (onboardingOpen) {
      trackActionActivity("ONBOARDING_OPEN");
    }
  }, [onboardingOpen]);

  return (
    <>
      {!!onboardingOpen && (
        <Modal
          open={onboardingOpen}
          size={"onboarding"}
          children={<OnboardingContainer />}
          handleClose={() => setOnboardingOpen(null)}
          hideCloseButton={onboardingOpen !== "support"}
          primary={true}
        />
      )}
    </>
  );
};
export default OnboardingWrapper;
